import * as React from 'react';
import { flexRender } from '@tanstack/react-table';

const Cell = (props) => {
    const { cell, className, size, ...restProps } = props;
    return (React.createElement("td", { className: `h-p-${size}`, style: { width: `${cell.column.getSize()}px` }, ...restProps }, flexRender(cell.column.columnDef.cell, cell.getContext())));
};

export { Cell };
//# sourceMappingURL=Cell.js.map
